import { render, staticRenderFns } from "./KanbanViewV2.vue?vue&type=template&id=593dfc2e&"
import script from "./KanbanViewV2.vue?vue&type=script&lang=js&"
export * from "./KanbanViewV2.vue?vue&type=script&lang=js&"
import style0 from "./KanbanViewV2.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports